import BASE_URL from "../../config/api";
import axios from "axios";
import { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import { BsPencil, BsTrash } from "react-icons/bs";

const AllConstructs = () => {
  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState({});
  const [constructs, setConstructs] = useState([]);

  const runOnStart = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/construct/get-all-construction`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("userToken")}` },
      });
      setConstructs(response.data.data ?? []);
    } catch {
      toast.error("Failed to load constructions");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { runOnStart(); }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this construction entry? This cannot be undone.")) return;
    setDeleteLoading((p) => ({ ...p, [id]: true }));
    try {
      const res = await axios.delete(`${BASE_URL}/construct/delete-construction/${id}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("userToken")}` },
      });
      if (res.status === 200) {
        toast.success("Deleted successfully");
        setTimeout(runOnStart, 1500);
      }
    } catch {
      toast.error("Failed to delete");
    } finally {
      setDeleteLoading((p) => ({ ...p, [id]: false }));
    }
  };

  return (
    <div>
      <ToastContainer />

      {/* Page header */}
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">All Constructions</h1>
          <p className="text-gray-500 text-sm mt-1">{constructs.length} entr{constructs.length !== 1 ? "ies" : "y"} in the system</p>
        </div>
        <Link
          to="/add-construction"
          className="bg-[#1877F2] hover:bg-[#0e5fc7] text-white text-sm font-bold px-5 py-2.5 rounded-full transition-colors duration-200"
        >
          + Add Construction
        </Link>
      </div>

      {loading ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100 animate-pulse">
              <div className="h-48 bg-gray-200" />
              <div className="p-4 space-y-2">
                <div className="h-3 bg-gray-200 rounded w-3/4" />
                <div className="h-8 bg-gray-200 rounded mt-3" />
              </div>
            </div>
          ))}
        </div>
      ) : constructs.length === 0 ? (
        <div className="text-center py-24 text-gray-400">
          <p className="text-5xl mb-4">🏗️</p>
          <p className="text-lg font-semibold">No constructions found</p>
          <Link to="/add-construction" className="mt-4 inline-block text-[#1877F2] underline text-sm font-medium">
            Add your first construction
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {constructs.map((item, i) => (
            <div key={i} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100 flex flex-col">
              <div className="relative h-48 flex-shrink-0 overflow-hidden bg-gray-100">
                <img
                  src={item.coverPhoto}
                  alt={item.title || "Construction"}
                  className="w-full h-full object-cover"
                />
                {item.status && (
                  <span className={`absolute top-2 left-2 text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wide ${
                    item.status === "Completed" ? "bg-green-500 text-white" : "bg-[#1877F2] text-white"
                  }`}>
                    {item.status}
                  </span>
                )}
              </div>
              <div className="p-4 flex flex-col flex-1">
                <p className="font-semibold text-gray-800 text-sm line-clamp-2 uppercase leading-snug">
                  {item.title}
                </p>
                {item.location && (
                  <p className="text-gray-400 text-xs mt-1">📍 {item.location}</p>
                )}
                <div className="flex gap-2 mt-3">
                  <Link
                    to={`/add-pictures/${item._id}`}
                    className="flex-1 flex items-center justify-center gap-1.5 py-2 px-3 bg-gray-100 hover:bg-[#1877F2]/10 text-gray-600 hover:text-[#1877F2] text-xs font-semibold rounded-xl border border-gray-200 hover:border-[#1877F2]/30 transition-colors duration-200"
                  >
                    <BsPencil size={12} /> Edit
                  </Link>
                  <button
                    onClick={() => handleDelete(item._id)}
                    disabled={deleteLoading[item._id]}
                    className="flex-1 flex items-center justify-center gap-1.5 py-2 px-3 bg-gray-100 hover:bg-red-50 text-gray-600 hover:text-red-500 text-xs font-semibold rounded-xl border border-gray-200 hover:border-red-200 transition-colors duration-200 disabled:opacity-50"
                  >
                    <BsTrash size={12} /> {deleteLoading[item._id] ? "Deleting…" : "Delete"}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AllConstructs;
